module.exports = __webpack_public_path__ + "img/icon-step@3x5.b6ab740c.png";